export const BASIC_GROWTH_RATES_ID_LIST = [51, 52, 53];
